export const getSetsPerLine = (
  sets: string[] | Record<string, unknown>[],
  settings: any,
): number => {
  if (settings.setsPerLine !== "auto") return Number(settings.setsPerLine);
  return sets.length > 6 ? 6 : sets.length;
};
